import { useState, useEffect } from "react";
import { SERVICES } from "../services";
import React from "react";
import {
  utils,
  Notifications,
  Accordion,
  BasicRow,
  TextCell,
  Table,
  RawCell,
  CellHeader,
  ActionButton,
  ActionButtonsCell,
  SelectComponent,
} from "@truenorthmortgage/olympus";
import Loading from "../components/Loading";
import NavComponent from "../components/NavComponent";
import NotificationComponent from "../components/NotificationComponent";
import { PhoneLink } from "../components";
import BreadcrumbsComponent from "../components/BreadcrumbsComponent";
import KratosModal from "../components/Modals/KratosModal";
import PurchaseModal from "../components/Modals/ActionQueue/PurchaseModal";
import { useParams, useSearchParams } from "react-router-dom";
import { InvestorStatementService } from "../services/investor-statement-service";
import { InvestmentAccountService } from "../services/investment-account-service";
import { notify, downloadPdf } from "../utils";
import { ERROR } from "../constants";

const Statements = () => {
  const [isLoading, setIsLoading] = useState(true);

  const investorStatementService =
    utils.injection.useInjection<InvestorStatementService>(
      SERVICES.InvestorStatementService
    );

  //const { investor_account_uuid } = useParams();

  const breadcrumbs = [
    { label: "Dashboard", path: "/dashboard" },
    {
      label: "Annual Investor Reports",
      path: "/annual-investor-reports/",
    },
  ];

  // Investor Account Friendly Id
  const [investorAccountFriendlyId, setInvestorAccountFriendlyId] =
    useState("");
  const [investorAccountUUID, setInvestorAccountUUID] = useState("");

  const [investorHtmlWrapper, setInvestorHtmlWrapper] = useState<JSX.Element[]>(
    []
  );

  const [currentDate] = useState(new Date().getFullYear());
  const [hideDropdowns, setHideDropDowns] = useState(true);

  useEffect(() => {
    const submitValues = {
      uuid: "" ?? null,
    };
    investorStatementService
      .getInvestorStatementData({ InvestorAccountForm: submitValues })
      .then((data) => {
        setInvestorAccounts(data);
        setIsLoading(false);
      })
      .catch((error) => {
        notify(error?.message ?? ERROR.INTERNAL_SERVER_ERROR.label, "error");
        setIsLoading(false);
      });
  }, []);

  // Store Entire BreadCrumb
  //localStorage.setItem("breadcrumbs", JSON.stringify(breadcrumbs));

  const [investorAccounts, setInvestorAccounts] = useState<
    Record<string, InvestorAccount>
  >({});

  const downloadMonthlyReport = (
    month: any,
    year: any,
    investmentAccountFriendlyID: any
  ) => {
    setIsLoading(true);
    // Make API request to kratos to download the monthly statement
    const submitValues = {
      investment_account_uuid: investmentAccountFriendlyID ?? null,
      month: month ?? null,
      year: year ?? null,
    };
    investorStatementService
      .downloadMonthlyReport({ monthlyReportData: submitValues })
      .then((data) => {
        downloadPdf(
          data?.report_data,
          year,
          month,
          investmentAccountFriendlyID,
          "monthly"
        );
        setIsLoading(false);
      })
      .catch((error) => {
        notify(error?.message ?? ERROR.INTERNAL_SERVER_ERROR.label, "error");
        setIsLoading(false);
      });
  };

  const downloadAnnualReport = (
    year: any,
    investor_account_friendly_id: any
  ) => {
    setIsLoading(true);
    // Make a API request to kratos to download the current year file !
    const submitValues = {
      investor_account_uuid: investorAccountUUID ?? null,
      year: year ?? null,
    };
    investorStatementService
      .downloadAnnualReport({ AnnualReportForm: submitValues })
      .then((data) => {
        downloadPdf(
          data?.report_data,
          year,
          null,
          investor_account_friendly_id,
          "annual"
        );
        setIsLoading(false);
      })
      .catch((error) => {
        notify(error?.message ?? ERROR.INTERNAL_SERVER_ERROR.label, "error");
        setIsLoading(false);
      });
  };

  const [investorAccountTitle, setInvestorAccountTitle] = useState("");

  interface InvestorAccount {
    uuid: string;
    name: string;
    friendly_id: string;
    type_label: string;
    [key: string]: any;
  }

  const DynamicAccordions = (
    activationDate: any,
    investmentAccountUUID: any,
    investmentAccountFriendlyID: any
  ) => {
    if (!activationDate) return null;

    const startDate = new Date(activationDate);
    const currentYear = new Date().getFullYear();
    const currentDate = new Date();
    const activationYear = startDate.getFullYear();
    const activationMonth = startDate.getMonth();
    const accordions = [];
    const currentMonth = currentDate.getMonth();

    // Loop through the years and generate the accordions
    for (let year = currentYear; year >= activationYear; year--) {
      // Skip the current year only generate previous years !
      const months = [];
      const startMonth = year === activationYear ? activationMonth : 0;
      const endMonth = year === currentYear ? currentMonth : 11;

      for (let month = startMonth; month <= endMonth; month++) {
        const date = new Date(year, month, 1);
        const label = `${date.toLocaleString("default", {
          month: "long",
        })} ${year}`;
        const shortMonth = date.toLocaleString("default", { month: "short" });
        const fullMonth = date.toLocaleString("default", { month: "long" });
        const fullyear = date.getFullYear();
        const numbered_month = date.getMonth() + 1;

        months.push(
          <BasicRow key={year} rowClasses={["white-row"]}>
            <RawCell className="black-bold">{`${shortMonth}, ${fullyear}`}</RawCell>
            <RawCell className="black-bold">
              {`Monthly statement Personal Investor Account`}{" "}
              {investmentAccountFriendlyID}
            </RawCell>
            <RawCell className="black-bold">
              <ActionButton
                className=""
                id={`download-annual-report-${year}`}
                key={`download-annual-report-${year}`}
                callback={() =>
                  downloadMonthlyReport(
                    numbered_month,
                    year,
                    investmentAccountUUID
                  )
                }
              >
                <i
                  style={{ marginRight: "5px" }}
                  className="fa-solid fa-file-invoice"
                ></i>
              </ActionButton>
            </RawCell>
          </BasicRow>
        );
      }

      accordions.push(
        <Accordion
          key={year}
          heading=""
          subjects={[`${year} Monthly Statements`]}
          title=""
          itemsSize="two"
        >
          {/*TODO: Loop through each month for each year to generate the report links */}
          <Table className="primary overview-table table-no-display-block monthly-report-inner-table">
            <CellHeader className="table-header">
              <RawCell className="black-bold">Name</RawCell>
              <RawCell className="black-bold">Date</RawCell>
              <RawCell className="black-bold">Download</RawCell>
            </CellHeader>
            {months}
          </Table>
        </Accordion>
      );
    }

    return accordions.length > 0 ? (
      <div className="monthly-report-wrapper">{accordions}</div>
    ) : (
      <div className="monthly-report-wrapper">No monthly reports available</div>
    );
  };

  const [selectedInvestorAccountKey, setSelectedInvestorAccountKey] = useState<
    string | null
  >(null);

  const investor_account_callback = (val: any) => {
    if (val === "0") return; // prevent trigger on default select
    setInvestorAccountUUID(val);
    setInvestorAccountFriendlyId("");
    setSelectedInvestorAccountKey(val);
    setHideDropDowns(false);
  };

  interface InvestorAccount {
    uuid: string;
    name: string;
    friendly_id: string;
    type_label: string;
  }

  interface InvestmentAccount {
    uuid: string;
    user_nickname: string;
    friendly_id: string;
    activation_date: string;
    status: string;
    // other fields...
  }

  return isLoading ? (
    <Loading />
  ) : (
    <>
      <div className="dashboard-container">
        <NavComponent />
      </div>
      <div id="main" className="dashboard-content">
        <Notifications
          timeout={15000}
          customNotificationElement={<NotificationComponent />}
        />
        <div className="main-header">
          <BreadcrumbsComponent items={breadcrumbs} />
        </div>
        <div className="main-content">
          <div className="dashboard investment-listings-container">
            <h1
              style={{ textTransform: "capitalize", marginBottom: "3px" }}
              className={"mobile-header"}
            >
              Statements
            </h1>

            <h3 style={{ marginTop: "10px" }}>Choose Investor Account</h3>
            <div
              className="column date-select"
              style={{ marginBottom: "10px" }}
            >
              <SelectComponent
                id="investor_account"
                key="investor_account"
                defaultValue=""
                columnStyle={"no-padding right"}
                onChange={investor_account_callback}
              >
                <option key={"default_investor_account"} value={0}>
                  Choose Investor Account
                </option>

                {investorAccounts?.investor_accounts &&
                  Object.keys(investorAccounts.investor_accounts).length > 0 &&
                  Object.entries(investorAccounts.investor_accounts).map(
                    ([uuid, account]: [string, InvestorAccount]) => (
                      <option key={uuid} id={uuid} value={uuid}>
                        {account?.name} - {account?.type_label}
                      </option>
                    )
                  )}
              </SelectComponent>
            </div>

            {!hideDropdowns ? (
              <div className={"annual-report-wrapper"}>
                <>
                  <h2>Annual Statements</h2>

                  <div className="divider" />
                  <Table className="primary annual-report-table overview-table table-no-display-block">
                    <CellHeader className="table-header">
                      <RawCell className="black-bold">Name</RawCell>
                      <RawCell className="black-bold">Date</RawCell>
                      <RawCell className="black-bold">Download</RawCell>
                    </CellHeader>
                    {selectedInvestorAccountKey &&
                      (() => {
                        const investorAccount =
                          investorAccounts?.investor_accounts?.[
                            selectedInvestorAccountKey
                          ];
                        if (!investorAccount?.investment_accounts) return null;

                        // Get the earliest activation date from all investment accounts
                        const activationDates = Object.values(
                          investorAccount.investment_accounts
                        )
                          .map((acc: any) => acc?.activation_date)
                          .filter(Boolean)
                          .map((date) => new Date(date).getFullYear());

                        const earliestYear =
                          activationDates.length > 0
                            ? Math.min(...activationDates)
                            : currentDate;

                        // Generate rows for each year from earliest activation to current year
                        const years = [];
                        for (
                          let year = currentDate;
                          year >= earliestYear;
                          year--
                        ) {
                          years.push(
                            <BasicRow key={year} rowClasses={["white-row"]}>
                              <RawCell className="black-bold">
                                {year} {investorAccount?.name}
                              </RawCell>
                              <RawCell className="black-bold">
                                {year} Annual statement{" "}
                                {investorAccount?.type_label} Investor Account
                              </RawCell>
                              <RawCell className="black-bold">
                                <ActionButton
                                  className={""}
                                  id={`download-annual-report-${year}`}
                                  key={`download-annual-report-${year}`}
                                  callback={() =>
                                    downloadAnnualReport(
                                      year,
                                      investorAccountUUID
                                    )
                                  }
                                >
                                  <i
                                    style={{ marginRight: "5px" }}
                                    className="fa-solid fa-file-invoice"
                                  ></i>
                                </ActionButton>
                              </RawCell>
                            </BasicRow>
                          );
                        }

                        return years;
                      })()}
                  </Table>

                  <h2>Monthly Statements </h2>

                  {selectedInvestorAccountKey &&
                    (() => {
                      return Object.entries(
                        investorAccounts?.investor_accounts?.[
                          selectedInvestorAccountKey
                        ]?.investment_accounts ?? {}
                      ).map(([uuid, account]) => {
                        const acc = account as any;
                        return (
                          <div key={acc?.uuid}>
                            <h3 style={{ marginBottom: "5px" }}>
                              {acc?.type_label} {acc?.user_nickname}
                            </h3>
                            <h4 style={{ marginTop: "0px" }}>
                              {acc?.morcado_id}
                            </h4>
                            {DynamicAccordions(
                              acc?.activation_date,
                              acc?.uuid,
                              acc?.friendly_id
                            )}
                          </div>
                        );
                      });
                    })()}
                </>
              </div>
            ) : null}

            <div className="footer-content"></div>
          </div>
        </div>
      </div>

      <div className="footer">
        <div className="footer__phone-link">
          Need help?
          <PhoneLink />
        </div>
      </div>
    </>
  );
};

export default Statements;
